// src/geoData.js
export const geoPages = [
    {
      slug: 'carreleur-peronne',
      ville: 'Péronne',
      dptArticle: "la",
      departement: 'Somme (80)',
      quartiers: 'Péronne, Saint-Radegonde, Doingt-Flamicourt',
      title: 'Carreleur à Péronne (80) – Darduin Carrelage | Devis Gratuit',
      description: 'Artisan carreleur à Péronne (Somme). Pose carrelage, douche italienne, terrasse. Intervention rapide depuis Marchélepot. Devis gratuit.',
    },
    {
      slug: 'carreleur-roye',
      ville: 'Roye',
      dptArticle: "la",
      departement: 'Somme (80)',
      quartiers: 'Roye, Goyencourt, Andechy',
      title: 'Carreleur à Roye (80) – Darduin Carrelage | Devis Gratuit',
      description: 'Pose et rénovation de carrelage à Roye (Somme 80). Artisan local depuis 2020, garantie décennale. Contactez Darduin Carrelage pour un devis gratuit.',
    },
    {
      slug: 'carreleur-ham',
      ville: 'Ham',
      dptArticle: "la",
      departement: 'Somme (80)',
      quartiers: 'Ham, Eppeville, Offoy',
      title: 'Carreleur à Ham (80) – Darduin Carrelage | Devis Gratuit',
      description: 'Artisan carreleur à Ham (Somme). Pose carrelage, faïence, douche italienne, terrasse. Devis gratuit. Darduin Carrelage intervient dans tout le secteur de Ham.',
    },
    {
      slug: 'carreleur-montdidier',
      ville: 'Montdidier',
      dptArticle: "la",
      departement: 'Somme (80)',
      quartiers: 'Montdidier, Gratibus, Rollot',
      title: 'Carreleur à Montdidier (80) – Darduin Carrelage | Devis Gratuit',
      description: 'Pose de carrelage et rénovation à Montdidier (Somme 80). Artisan carreleur depuis 2020, garantie décennale. Devis gratuit.',
    },
    {
      slug: 'carreleur-amiens',
      ville: 'Amiens',
      dptArticle: 'la',
      departement: 'Somme (80)',
      quartiers: 'Amiens, Saint-Leu, Henriville, Longueau, Rivery',
      title: 'Carreleur à Amiens (80) – Darduin Carrelage | Devis Gratuit',
      description: 'Artisan carreleur à Amiens (Somme). Pose carrelage, douche italienne, terrasse, parquet. Devis gratuit. Darduin Carrelage intervient sur Amiens et agglomération.',
    },
    {
      slug: 'carreleur-arras',
      ville: 'Arras',
      dptArticle: 'le',
      departement: 'Pas-de-Calais (62)',
      quartiers: 'Arras, Beaurains, Saint-Nicolas-lez-Arras',
      title: 'Carreleur à Arras (62) – Darduin Carrelage | Devis Gratuit',
      description: 'Pose de carrelage à Arras (Pas-de-Calais). Artisan carreleur avec garantie décennale. Salle de bain, terrasse, douche italienne. Devis gratuit.',
    },
    {
      slug: 'carreleur-saint-quentin',
      ville: 'Saint-Quentin',
      dptArticle: "l'",
      departement: 'Aisne (02)',
      quartiers: 'Saint-Quentin, Fayet, Gauchy',
      title: 'Carreleur à Saint-Quentin (02) – Darduin Carrelage | Devis Gratuit',
      description: 'Artisan carreleur à Saint-Quentin (Aisne 02). Pose et rénovation carrelage, salle de bain, terrasse. Garantie décennale. Devis gratuit.',
    },
    {
      slug: 'carreleur-compiegne',
      ville: 'Compiègne',
      dptArticle: "l'",
      departement: 'Oise (60)',
      quartiers: 'Compiègne, Margny-lès-Compiègne, Clairoix',
      title: 'Carreleur à Compiègne (60) – Darduin Carrelage | Devis Gratuit',
      description: 'Pose de carrelage à Compiègne (Oise). Douche italienne, terrasse, rénovation salle de bain. Artisan carreleur avec garantie décennale. Devis gratuit.',
    },
  ];

  export const defaultGeoData = {
    slug: "",
    description: 'Artisan carreleur à Marchélepot (Somme). Pose carrelage, douche italienne, terrasse. Intervention rapide depuis Marchélepot. Devis gratuit.',
    title: 'Carreleur hauts-de-france | Darduin Carrelage | Devis Gratuit'
}